(() => {
    "use strict";

    window.siteReady = function siteReady(callback) {
        const run = () => callback();
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", run);
        } else {
            run();
        }
        document.addEventListener("site:navigated", run);
    };
})();
